export default "data:image/svg+xml,united_nations.svg"